export enum GuidedTourActions {
  Scroll_Dismissed = 'Scroll_Dismissed',
}

export const dismissScrollTour = {
  type: GuidedTourActions.Scroll_Dismissed,
};
